import { AsgardDocEpub } from "src/app/core/documents/asgard-doc-epub";
import { AsgardCommandBase } from "../command-base";

// Command created just to trigger autosave
export class EpubAnnotationCommand extends AsgardCommandBase {
    constructor(
        public doc: AsgardDocEpub,
    ) {
        super(doc);
    }

    async execute() { }

    async undo() { }
}
